// 운영 도메인에서만 라이브 키 사용 — 로컬·테스트 배포는 같은 빌드여도 테스트 키로 동작
const LIVE_HOSTNAMES = ['www.rappomanager.com', 'rappomanager.com'];

export const getTossClientKey = (hostname: string) =>
    LIVE_HOSTNAMES.includes(hostname)
        ? process.env.REACT_APP_TOSS_NORMAL_PAYMENT_LIVE_CLIENT_KEY
        : process.env.REACT_APP_TOSS_NORMAL_PAYMENT_TEST_CLIENT_KEY;

export const loadTossScript = () =>
    new Promise<void>((resolve, reject) => {
        if ((window as any).TossPayments) {
            resolve();
            return;
        }

        const existScript = document.querySelector('script[data-toss-sdk="true"]') as HTMLScriptElement | null;
        if (existScript) {
            existScript.addEventListener('load', () => resolve(), { once: true });
            existScript.addEventListener('error', () => reject(new Error('토스 SDK 로드 실패')), { once: true });
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://js.tosspayments.com/v2/standard';
        script.async = true;
        script.dataset.tossSdk = 'true';
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('토스 SDK 로드 실패'));
        document.head.appendChild(script);
    });

interface GiftTossPaymentParams {
    orderId: string;
    orderName: string;
    amount: number;
    customerName: string;
}

/** 신용·체크카드 선택 시 토스 테스트 결제창 호출 — 성공/실패 시 /gift-pay 완료·실패 페이지로 리다이렉트 */
export const requestGiftTossPayment = async ({ orderId, orderName, amount, customerName }: GiftTossPaymentParams) => {
    await loadTossScript();

    const tossClientKey = getTossClientKey(window.location.hostname);

    if (!tossClientKey) {
        throw new Error('토스 클라이언트 키가 설정되지 않았어요.');
    }

    if (!(window as any).TossPayments) {
        throw new Error('토스 SDK 초기화 실패');
    }

    const tossPayments = (window as any).TossPayments(tossClientKey);
    const payment = tossPayments.payment({
        customerKey: 'ANONYMOUS',
    });

    await payment.requestPayment({
        method: 'CARD',
        amount: {
            currency: 'KRW',
            value: amount,
        },
        orderId,
        orderName,
        successUrl: `${window.location.origin}/gift-pay/${orderId}/complete`,
        failUrl: `${window.location.origin}/gift-pay/${orderId}/fail`,
        customerName,
        card: {
            useEscrow: false,
            flowMode: 'DEFAULT',
            useCardPoint: false,
            useAppCardOnly: false,
        },
    });
};
